import { render, staticRenderFns } from "./tagsView.vue?vue&type=template&id=38ee146e&scoped=true&"
import script from "./tagsView.vue?vue&type=script&lang=js&"
export * from "./tagsView.vue?vue&type=script&lang=js&"
import style0 from "./tagsView.vue?vue&type=style&index=0&id=38ee146e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee146e",
  null
  
)

export default component.exports